import { useEffect, useMemo, useState } from 'react';
import { Option } from '../../../../general-types';
import { CoachOptionInfo } from '../../../../shared/interfaces/coach/CoachOptionInfo';
import { coachService } from '../../../../shared/services/coach/coachService';
import { transformToOptions } from '../../../../shared/utils/arrayUtils/transformToOptions/transformToOptions';
import { addAllOption } from '../../../../shared/utils/arrayUtils';
import { sortArrAlphabetically } from '../../../../shared/utils/sortingAndGroupingUtil';

export const useCoachOptions = (entityId: number): Option[] => {
  const [coachList, setCoachList] = useState<CoachOptionInfo[]>([]);

  const getCoachOptions = async () => {
    const { coaches } = await coachService.getCoachOptions(entityId);

    setCoachList(coaches);
  };

  useEffect(() => {
    getCoachOptions();
  }, [entityId]);

  const options = useMemo(() => {
    const sorted = sortArrAlphabetically(coachList, 'fullName');
    const transformedOptions = transformToOptions({
      list: sorted,
      valueKey: 'id',
      labelKey: 'fullName',
    });

    return addAllOption(transformedOptions, true);
  }, [coachList]);

  return options;
};
